import React, { Component } from 'react';
import { connect } from "react-redux";
import { auth } from '../../config/firebase';
import { Field, reduxForm } from 'redux-form';

import { login } from '../../redux/actions';

import { ShortField, PasswordRegister } from '../atoms/formElements/formElements';
import Button from '../atoms/button/button';
import Tabs from '../organisms/tabs/tabs';
import SideModal from '../molecules/modal/sideModal';

class Login extends Component {
  formSubmit = (values) => {
    auth.signInWithEmailAndPassword(values.email, values.password).then(result => {
      this.props.login(result.user);
    }).catch(function(error) { alert(error) });

  }
  render() {
    const { state, handleSubmit, companyInfo } = this.props
    return (
      <SideModal active={state ? 'active' : null } screen='login' >
        <div className='loginWrapper'>
          <img alt="logo" className='logoMedium center' src={companyInfo.logo}></img>
          <form onSubmit={handleSubmit(this.formSubmit)}>
            <Field name='email' label='Email' component={ShortField} type='text' />
            <Field name='password' label='Password' component={PasswordRegister} type='password' screen='login' />
            <Button label='Login' disabled='false' type='submit' />
          </form>
        </div>
      </SideModal>
    )
  }
}

function mapStateToProps(state) {
  return {
    user: state.user,
    companyInfo: state.general.company.info,
    state: state.overlays.login
  };
}

export default reduxForm({
  // validate,
  form: 'signInForm',
})( connect(mapStateToProps, { login })(Login));
